import { StaticPricingTab } from './pricing-display-static.types';

const ftpHeaders = [
  'Annual Processing Not To Exceed',
  'Evaluation Fee',
  'One Year Contract',
  'Two Year Contract',
  'Three Year Contract',
];

const ftpRows = (prices: string[][]) =>
  prices.map(([volume, y1, y2, y3]) => [volume, '$250.00', y1, y2, y3]);

export const DQ_PRICING_TAB: StaticPricingTab = {
  id: 'dq',
  label: 'DQ',
  tabNotes: [{ type: 'heading', text: 'ACCUZIP DATA QUALITY PRICING' }],
  sections: [
    {
      title:
        'CASS Certification FTP or SFTP (2 Processes) - Annual Processing Not To Exceed',
      headers: ftpHeaders,
      rows: ftpRows([
        ['1,000,000', '$1,950', '$3,120', '$3,803'],
        ['5,000,000', '$2,950', '$4,720', '$5,753'],
        ['10,000,000', '$3,950', '$6,320', '$7,703'],
        ['25,000,000', '$4,950', '$7,920', '$9,653'],
        ['50,000,000', '$5,950', '$9,520', '$11,603'],
        ['100,000,000', '$6,950', '$11,120', '$13,553'],
        ['200,000,000', '$7,950', '$12,720', '$15,503'],
        ['300,000,000', '$8,950', '$14,320', '$17,453'],
        ['500,000,000', '$10,000.00', '$16,000', '$19,500'],
      ]),
    },
    {
      title:
        'CASS & NCOALink with ANKLink Certification FTP or SFTP (2 Processes) - Annual Processing Not To Exceed',
      headers: ftpHeaders,
      rows: ftpRows([
        ['1,000,000', '$2,925', '$4,680', '$5,704'],
        ['5,000,000', '$4,425', '$7,080', '$8,629'],
        ['10,000,000', '$5,925', '$9,480', '$11,554'],
        ['25,000,000', '$7,425', '$11,880', '$14,479'],
        ['50,000,000', '$8,925', '$14,280', '$17,404'],
        ['100,000,000', '$10,425', '$16,680', '$20,329'],
        ['200,000,000', '$11,925', '$19,080', '$23,254'],
        ['300,000,000', '$13,425', '$21,480', '$26,179'],
        ['500,000,000', '$15,000', '$24,000', '$29,250'],
      ]),
    },
    {
      title:
        'CASS & NCOALink 48-Month Certification FTP or SFTP (2 Processes) - Annual Processing Not To Exceed',
      headers: ftpHeaders,
      rows: ftpRows([
        ['1,000,000', '$3,539', '$5,663', '$6,902'],
        ['5,000,000', '$5,354', '$8,567', '$10,441'],
        ['10,000,000', '$7,169', '$11,471', '$13,980'],
        ['25,000,000', '$8,984', '$14,375', '$17,519'],
        ['50,000,000', '$10,799', '$17,279', '$21,059'],
        ['100,000,000', '$12,614', '$20,183', '$24,598'],
        ['200,000,000', '$14,429', '$23,087', '$28,137'],
        ['300,000,000', '$16,244', '$25,991', '$31,676'],
        ['500,000,000', '$18,150', '$29,040', '$35,393'],
      ]),
    },
    {
      title:
        'NCOALink with ANKLink Certification Only (Customer Using Alternate CASS) FTP or SFTP (2 Processes) - Annual Processing Not To Exceed',
      headers: ftpHeaders,
      rows: ftpRows([
        ['1,000,000', '$2,633', '$4,212', '$5,133'],
        ['5,000,000', '$3,983', '$6,372', '$7,766'],
        ['10,000,000', '$5,333', '$8,532', '$10,398'],
        ['25,000,000', '$6,683', '$10,692', '$13,031'],
        ['50,000,000', '$8,033', '$12,852', '$15,663'],
        ['100,000,000', '$9,383', '$15,012', '$18,296'],
        ['200,000,000', '$10,733', '$17,172', '$20,928'],
        ['300,000,000', '$12,083', '$19,332', '$23,561'],
        ['500,000,000', '$13,500', '$21,600', '$26,325'],
      ]),
    },
    {
      title:
        'NCOALink 48-Month Certification Only (Customer Using Alternate CASS) FTP or SFTP (2 Processes) - Annual Processing Not To Exceed',
      headers: ftpHeaders,
      rows: ftpRows([
        ['1,000,000', '$3,185', '$5,097', '$6,211'],
        ['5,000,000', '$4,819', '$7,710', '$9,397'],
        ['10,000,000', '$6,452', '$10,324', '$12,582'],
        ['25,000,000', '$8,086', '$12,937', '$15,767'],
        ['50,000,000', '$9,719', '$15,551', '$18,953'],
        ['100,000,000', '$11,353', '$18,165', '$22,138'],
        ['200,000,000', '$12,986', '$20,778', '$25,323'],
        ['300,000,000', '$14,620', '$23,392', '$28,509'],
        ['500,000,000', '$16,335', '$26,136', '$31,853'],
      ]),
    },
    {
      title: 'Desktop Processing (Windows PC)',
      headers: [
        'Product',
        '',
        'One Year Contract',
        'Two Year Contract',
        'Three Year Contract',
      ],
      rows: [
        [
          'AccuMUVXtreme CASS and NCOA (no scripting)',
          '',
          '$1,295.00',
          '$2,331.00',
          '$3,108.00',
        ],
      ],
    },
    {
      title: 'AccuMUVXtreme Addons',
      headers: [
        'Product',
        '',
        'One Year Contract',
        'Two Year Contract',
        'Three Year Contract',
      ],
      rows: [
        ['AccuGeocoder', '', '$995', '$1,695', '$2,295'],
        ['Z4Change (Site License Fee)', '', '$3,000', '$5,400', '$7,200'],
        ['Residential Delivery Indicator (RDI)', '', '$295', '$575', '$795'],
      ],
    },
    {
      title: 'On-Premise Unlimited NCOA Processing',
      headers: [
        'Product',
        'Evaluation Fee',
        'One Year Contract',
        'Two Year Contract',
        'Three Year Contract',
      ],
      rows: [
        [
          'Tier 1 (Includes On-Premise API CASS, Server Setup and NCOA Processing Onsite)',
          '',
          '$29,950',
          '$47,920.00',
          '$58,402.50',
        ],
      ],
    },
    {
      title: 'Professional Services',
      headers: ['Service', 'Rate', 'Terms'],
      rows: [
        ['Onsite', '$1,500', 'per day plus travel expenses'],
        ['In house', '$200', 'per hour'],
      ],
    },
    {
      title: 'ACCUZIP DATA QUALITY PRODUCT LINE',
      headers: [],
      rows: [],
      notes: [
        { type: 'heading', text: 'AccuZIP Toolkit' },
        {
          type: 'list-item',
          text: 'Developed in C# using the .NET Framework. Available in 32bit or 64bit',
        },
        {
          type: 'list-item',
          text: 'Embed our iron‐clad CASS Certified™ AccuZIP Data Quality Toolkit within your own applications, website, or databases',
        },
        {
          type: 'list-item',
          text: 'License our iron‐clad data quality technology and integrate the toolkit into your website or customer internal application and databases to correct and standardize all of your U.S. addresses.',
        },
        {
          type: 'list-item',
          text: 'Our new COM Object Toolkit can be called from virtually every programming environment like Java, C#, C++, C, Visual Basic, Visual FoxPro, etc.',
        },
        {
          type: 'list-item',
          text: 'The AccuZIP Data Quality Developer Toolkit is CASS Certified and includes RDI™, ZIP+4™, DPV®, eLOT®, LACSLink®, and SuiteLINK®.',
        },
        {
          type: 'list-item',
          text: 'Address Correction for Point of Entry and Batch (NCOA accomplished via FTP)',
        },
        { type: 'heading', text: 'AccuZIP CASS REST API ‐ Web service' },
        { type: 'list-item', text: 'Nothing to install' },
        {
          type: 'list-item',
          text: 'CASS Certified individual or multiple addresses',
        },
        { type: 'list-item', text: 'Responses in JSON or XML format' },
        { type: 'list-item', text: 'https://api.iaccutrace.com/docs/api‐cass' },
        { type: 'list-item', text: '1 to 100 addresses at a time' },
        { type: 'heading', text: 'AccuGeocoder Toolkit' },
        {
          type: 'list-item',
          text: 'Developed in C# using the .NET Framework. Available in 32bit or 64bit',
        },
        {
          type: 'list-item',
          text: 'Contains Maponics ZIP+4 Database Premium Plus Centroids data',
        },
        {
          type: 'list-item',
          text: 'Enhance each matching address and add ZIP+4 level latitude and longitude values for ultimate mapping precision.',
        },
        {
          type: 'list-item',
          text: 'Add latitude and longitude coordinates carried out to the 6th decimal.',
        },
        {
          type: 'list-item',
          text: 'Add Census Tract numbers and Census Block group numbers',
        },
        {
          type: 'list-item',
          text: 'Can be plugged into API, Web Service for FTP',
        },
        { type: 'heading', text: 'NCOALink with ANKLink (Cloud‐Batch)' },
        {
          type: 'list-item',
          text: 'Upload an unlimited number of CASS Certified and standardized name and address records to our cloud NCOALink and ANKLink service via FTP or SFTP 24/7.',
        },
        {
          type: 'paragraph',
          text: 'The "Batch" process is a specific documented format, and then only the matches are sent back to them in a specific documented format',
        },
        { type: 'heading', text: 'AccuZIP CASS (Cloud‐Batch)' },
        {
          type: 'list-item',
          text: 'Upload an unlimited number of address records to our cloud CASS service via FTP or SFTP 24/7.',
        },
        {
          type: 'heading',
          text: 'NCOALink with ANKLink Build Installer and Matching Engine (User Site)',
        },
        { type: 'list-item', text: 'Not for Resellers' },
        { type: 'list-item', text: 'Resellers' },
        { type: 'list-item', text: 'In‐house NCOALink and ANKLink service' },
        { type: 'heading', text: 'Z4 Change' },
        {
          type: 'paragraph',
          text: 'Z4Change should only be used on a previously CASS Certified address. I would limit Z4Change to "Batch" processes only, not Web Service. It is also called as a seperate "function" in the API',
        },
        {
          type: 'paragraph',
          text: 'The Z4Change function returns the number of months, 0-12, that the passed ZIP+4 had any activity',
        },
        {
          type: 'paragraph',
          text: 'So if you CASS Certified an address using January 15, 2014 data, then a change to the ZIP+4 code occurred in February 2014 and you were calling Z4Change function in March 2014, it would return the number 1, indicating there is activity on that +4 in February. Then you would call the CASS API function to re-CASS Certify that record',
        },
      ],
    },
  ],
};
